<template>
  <GModal ref="modalUserPhotos" class="modal--user-photos">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>

      <h2 class="modal-heading">USER PHOTOS ({{ totalUserPhoto }})</h2>
    </div>

    <div slot="body">
      <UserPhotosSlide key="GlobalUserPhotosSlide" />
    </div>
  </GModal>
</template>

<script>
import UserPhotosSlide from './user-photos-slide';

export default {
  name: 'global-modal-user-photos',
  components: {
    UserPhotosSlide,
  },
  computed: {
    totalUserPhoto() {
      return this.$store.state.modal.userPhotos.totalUserPhoto;
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('setOpenModal', {
        stateName: 'userPhotos',
        newVal: false,
      });
    },
  },
};
</script>
